<template>
  <div class="sample-uploads">
    <b-row>
      <b-col :lg="8" v-if="!loading">
        <div v-for="task in uploadTasks" :key="task.id">
          <div
            class="doc-upload-container"
            v-for="uploadDoc in task.upload_docs"
            :key="uploadDoc.key"
          >
            <sample-upload
              :task="task"
              @added="uploadInProgress++"
              @complete="uploadInProgress--"
              @success="success(task, uploadDoc)"
              @fileRemoved="fileRemoved(uploadDoc)"
              :uploadDoc="uploadDoc"
            />
            <span
              class="error"
              v-show="triedSubmit && uploads.indexOf(uploadDoc.key) === -1"
              >{{ $t('buyers.add.form.required') }}</span
            >
          </div>
        </div>
      </b-col>
      <div class="col-sm-12" v-else>
        <loader :height="200" />
      </div>
    </b-row>
    <form-button
      :loading="loading"
      type="submit"
      variant="primary"
      @click="stepChange()"
      class="button-buyer-form"
    >
      {{ $t('buyers.add.form.next') }}
    </form-button>
  </div>
</template>
<script>
import Loader from '@/components/common/Loader'
import SampleUpload from '@/components/buyers/SampleUpload'
import FormButton from '@/components/common/FormButton'

export default {
  data() {
    return {
      loading: false,
      exporterId: this.$store.state.account.accountId,
      uploadInProgress: 0,
      triedSubmit: false
      // todo: don't use state
    }
  },
  computed: {
    uploadTasks() {
      if (!this.buyer.customer_task_flows) {
        return []
      }
      return this.buyer.customer_task_flows
    }
  },
  mounted() {
    document.title = 'Buyer | Drip Portal'
    this.$mpTrack('Add Buyer - Buyer Uploads page loaded')
    this.$emit('loadBuyer')
  },
  methods: {
    success(task, uploadDoc) {
      this.$emit('updatedUploads', uploadDoc.key)
      task.status = 'done'
    },
    stepChange(where) {
      if (this.uploadValidate()) {
        this.$mpTrack('Add Buyer - Go to buyer information')
        return where === 'back'
          ? this.$emit('prevStep')
          : this.$emit('nextStep')
      } else {
        this.$mpTrack('Add Buyer - Uploaded documents pending')
      }
    },
    uploadValidate() {
      this.triedSubmit = true
      return this.uploads.length === 2
    },
    fileRemoved(uploadDoc) {
      this.uploads.splice(this.uploads.indexOf(uploadDoc.key), 1)
    }
  },
  props: ['buyer', 'uploads'],
  components: {
    Loader,
    SampleUpload,
    FormButton
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/variables';
.sample-uploads {
  .error {
    color: #e57373;
    font-size: 0.75rem;
    left: 0;
    top: auto;
    bottom: -1.5rem;
  }
}
@include media-breakpoint-down(sm) {
  .button-buyer-form {
    width: 100%;
  }
}
</style>
